const state = {
  loading: true,
};

const getters = {};

const mutations = {
  setLoading: (st, payload) => {
    st.loading = payload;
  },
};

const actions = {};

export default {
  state,
  getters,
  mutations,
  actions,
};



// WEBPACK FOOTER //
// ./src/store/modules/loader.js